import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-weave-search',
    templateUrl: './weave-search.component.html',
    styleUrls: ['./weave-search.component.scss'],
    standalone: false
})
export class WeaveSearchComponent implements OnInit {
  @Input() label: string = "Search";
  @Input() placeholder: string = "Search";
  @Input() searchQuery: string = "";
  @Output() onChange: EventEmitter<string> = new EventEmitter<string>();
  constructor() { }

  ngOnInit(): void {
  }

  filterItems() {
    this.onChange.emit(this.searchQuery);
  }

}
